import {
  oneDayInMilliseconds,
  getDifferenceInMillis,
} from 'helpers/dateHelper';
import {
  is1BPaid,
  isPlus1B,
  isPlus1BFreeTrial,
  isPreviouslyPremium,
} from 'helpers/userHelper';

export const canPurchase3BReport = props => {
  const { userInfo, creditReportRes } = props;
  if (!userInfo || !creditReportRes || isPreviouslyPremium(userInfo))
    return false;
  const last3BReportDownloaded = creditReportRes?.items?.filter(
    report => report.groupType === 'THREE_BUREAUS',
  );
  if (last3BReportDownloaded?.length === 0) return true;
  const last3BReportRefreshDate =
    last3BReportDownloaded?.length > 0
      ? last3BReportDownloaded[0]?.createDate
      : null;
  const past24HoursFromLastReportDownloaded =
    getDifferenceInMillis(null, last3BReportRefreshDate) >=
    oneDayInMilliseconds;
  const past30DaysFromLastReportDownloaded =
    getDifferenceInMillis(null, last3BReportRefreshDate) <=
    oneDayInMilliseconds * 30;
  if (userInfo?.premiumPlanInfo?.freeTrialPeriod) {
    return (
      past24HoursFromLastReportDownloaded &&
      userInfo?.premiumPlanInfo?.planSupports3bGatedDuringTrial
    );
  } else if (isPlus1B(userInfo) || isPlus1BFreeTrial(userInfo)) {
    return !last3BReportRefreshDate || past24HoursFromLastReportDownloaded;
  } else if (is1BPaid(userInfo)) {
    return past30DaysFromLastReportDownloaded;
  } else {
    return (
      (!last3BReportRefreshDate || past24HoursFromLastReportDownloaded) &&
      userInfo?.premiumPlanInfo?.next3BCreditReportDownloadDateInDays > 0
    );
  }
};
